import Image from 'next/image';

import { cn } from '@/lib/utils';

import dots from '@/public/career/dots-background-dark.svg';

/**
 * The pixel-grid decoration that sits behind the dark sections (Figma node
 * 9788:136179).
 *
 * The artwork is 959×202 in the design, so it carries that width in rem and
 * lets the height follow — scaling it is a matter of overriding the width.
 * Positioning is left to the caller: pass it through className, the way the
 * design hangs it 30px above its section.
 */
export default function DotsBackgroundDark({
  className,
}: {
  className?: string;
}) {
  return (
    <Image
      className={cn(
        'pointer-events-none h-auto w-[119.875rem] max-w-none select-none opacity-[0.06]',
        // the grid fades out over its bottom quarter rather than ending on a hard edge
        '[mask-image:linear-gradient(to_bottom,#000_75.83%,transparent_100%)]',
        className,
      )}
      src={dots}
      alt=""
      aria-hidden
    />
  );
}
